import React from "react";
import "../styles/print.stye.css";
import { thaiMonths } from "../../../../../utils/monthThai";
import { useLocation } from "react-router-dom";
import { formatDateToThai } from "../../../../../utils/date.utils";
import RenderValue from "./RenderValue";

const HeaderPrint = ({
  header,
  sub_header,
  title,
  send_to,
  data,
  form_code = "บค.",
  place_label = "เขียนที่",
  place_value = "วิทยาลัยพุทธศาสนานานาชาติ",
}: {
  header: string;
  sub_header: string;
  title: string;
  send_to: string;
  data: {
    title: string;
    date: Date;
  };
  form_code?: string;
  /* บรรทัดขวาบนเหนือวันที่ เช่น "เขียนที่ ..." (ค่าเริ่มต้น) หรือ "สัญญาเลขที่ ..." (บค. ๒๕) */
  place_label?: string;
  place_value?: any;
}) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const formType = queryParams.get("form");

  const {
    day: create_day,
    month: create_month,
    year: create_year,
  } = formatDateToThai(data ? data.date : null);

  return (
    <div className="w-full">
      {/* no */}
      <div className="w-full flex justify-end items-center space-content">
        {form_code}
      </div>
      {/* logo */}
      <div className="w-full flex justify-center items-center space-content">
        <img
          className="logo-header"
          src="/images/logo-mculg-custom-1.png"
          alt="Logo"
          width={100}
          height={100}
          style={{ width: 100, height: 100, objectFit: "contain" }}
        />
      </div>
      {/* header */}
      <div className="w-full flex justify-center items-center space-content title-header">
        <strong>{header}</strong>
      </div>
      <div className="w-full flex justify-center items-center space-content title-header">
        <strong>{sub_header}</strong>
      </div>

      {/* place */}
      <div className="w-full flex justify-end items-end space-content mt-4">
        <RenderValue
          start_label={place_label}
          end_label={null}
          length={60}
          value={place_value}
          isParagraph={false}
          grow={false}
        />
      </div>
      {/* date */}
      <div className="w-full flex justify-end items-end space-content">
        <RenderValue
          start_label={"วันที่"}
          end_label={null}
          length={20}
          value={create_day}
          isParagraph={false}
          grow={false}
        />
        <RenderValue
          start_label={"เดือน"}
          end_label={null}
          length={50}
          value={create_month?.toString() ? thaiMonths[create_month] : null}
          isParagraph={false}
          grow={false}
        />
        <RenderValue
          start_label={"พ.ศ."}
          end_label={null}
          length={30}
          value={create_year}
          isParagraph={false}
          grow={false}
        />{" "}
      </div>
      {/* dear */}
      <div className="w-full flex justify-start items-start space-content">
        <RenderValue
          start_label={"เรื่อง"}
          end_label={null}
          length={100}
          value={title}
          isParagraph={false}
        />
      </div>
      <div className="w-full flex justify-start items-start space-content">
        <RenderValue
          start_label={formType === "03" ? "นมัสการ" : "เรียน/นมัสการ"}
          end_label={null}
          length={100}
          value={send_to}
          isParagraph={false}
        />{" "}
      </div>
    </div>
  );
};

export default HeaderPrint;
